import { COPY_PX } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  segments: [],
  highValueWords: {},
  fetchSegmentsStatus: undefined,
  fetchHighValueWordsStatus: undefined,
  selectedSegmentIds: [],
  selectedClusterIds: [],
  gridState: {},
  controlledGridState: {},
  selectedGridRows: [],
  maxGridRowSelection: 1,
  copyPxScores: [],
  editSegmentStatus: undefined,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case COPY_PX.UNSET:
      return {
        ...state,
        [action.payload]: undefined,
      };
    case COPY_PX.SET_COPY_PX:
      return {
        ...state,
        copyPxScores: action.payload,
      };
    case COPY_PX.FETCH_SEGMENTS:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.STARTED,
      };
    case COPY_PX.FETCH_SEGMENTS_SUCCEEDED:
      return {
        ...state,
        segments: action.payload,
        fetchSegmentsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case COPY_PX.FETCH_SEGMENTS_FAILED:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.FAILED,
      };
    case COPY_PX.FETCH_HIGH_VALUE_WORDS:
      return {
        ...state,
        fetchHighValueWordsStatus: CONSTANTS.API.STARTED,
      };
    case COPY_PX.FETCH_HIGH_VALUE_WORDS_SUCCEEDED:
      return {
        ...state,
        highValueWords: action.payload,
        fetchHighValueWordsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case COPY_PX.FETCH_HIGH_VALUE_WORDS_FAILED:
      return {
        ...state,
        fetchHighValueWordsStatus: CONSTANTS.API.FAILED,
      };
    case COPY_PX.DESELECT_ALL_GRID_ROWS:
      return {
        ...state,
        controlledGridState: {
          selectedRowIds: {},
        },
        selectedSegmentIds: [],
        selectedClusterIds: [],
        selectedGridRows: [],
      };
    case COPY_PX.SET_GRID_STATE:
      return {
        ...state,
        gridState: action.payload,
        controlledGridState: {},
      };
    case COPY_PX.SET_SELECTED_GRID_ROWS:
      return {
        ...state,
        selectedGridRows: action.payload,
        selectedSegmentIds: action.payload
          .map(({ original: { id, datasetId } }) => (datasetId ? { segmentId: id, datasetId } : null))
          .filter((id) => id),
        selectedClusterIds: action.payload
          .map(({ original: { id, segmentId } }) => (segmentId ? { clusterId: id, segmentId } : null))
          .filter((value) => value),
        controlledGridState: {
          ...state.controlledGridState,
          selectedRowIds: Object.fromEntries(action.payload.map(({ id }) => [id, true])),
        },
      };
    case COPY_PX.EDIT_SEGMENT:
      return {
        ...state,
        editSegmentStatus: CONSTANTS.API.STARTED,
      };
    case COPY_PX.EDIT_SEGMENT_SUCCEEDED:
      return {
        ...state,
        segments: state.segments.map((segment) =>
          segment.id === action.payload.id ? { ...segment, ...action.payload.payload } : segment
        ),
        editSegmentStatus: CONSTANTS.API.SUCCEEDED,
      };
    case COPY_PX.EDIT_SEGMENT_FAILED:
      return {
        ...state,
        editSegmentStatus: CONSTANTS.API.FAILED,
      };
    default:
      return state;
  }
};
